var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_vm._v(" About manufacture "),_c('p',[_vm._v("Активирован: .....")]),_c('p',[_vm._v("Активен до: .....")]),_c('p',[_vm._v("Раширить хранилище....")]),_c('v-btn',{attrs:{"color":"success"}},[_vm._v("Оплатить")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }